<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CouponContent',
})
</script>
<template>
  <div
    class="couponContent"
    :id="props.componentId"
    v-show="couponData.data.length"
  >
    <client-only>
      <CouponDetail :coupons="couponData.data" :collapseCount="9" />
    </client-only>
  </div>
</template>
<script setup lang="ts" name="CouponContent">
import CouponDetail from '@/views/Console/Financial/Coupon/components/CouponDetail.vue'
import { isClient } from '@/utils/is'
import { SSRDataStore } from '@/store/modules/ssrData'
import {
  // isObject,
  isArray
} from '@/utils/is'

const ssrDataStore = SSRDataStore()

interface CouponType {
  componentId: string
}

const props = defineProps<CouponType>()
const couponData = reactive<{ [key: string]: any }>({ data: [] })

if (isClient() && ssrDataStore.couponsGet) {
  couponData.data = ssrDataStore.couponsGet
}

onServerPrefetch(async () => {
  if (
    ssrDataStore.componentsGet?.campaignIds &&
    isArray(ssrDataStore.componentsGet.campaignIds) &&
    ssrDataStore.componentsGet.campaignIds.length
  ) {
    await ssrDataStore.setMarketsData(ssrDataStore.componentsGet.campaignIds)
    couponData.data = ssrDataStore.couponsGet
  }
})
</script>
<style scoped lang="scss">
.couponContent {
  width: 1240px;
  margin: 0 auto;
  margin-bottom: 20px;
  :deep(.coupon-wrapper) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 15px;
    width: 100%;
    .coupon-card {
      width: 403px;
      height: min-content;
      margin-right: 0;
    }
  }
}
</style>
